var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"searchResult"},[_c('my-banner',{attrs:{"banner":_vm.banner}}),_c('my-notice',{ref:"notice",attrs:{"noticeTitle":_vm.noticeTitle}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }